<script>
import {validationMixin} from 'vuelidate'
import {required, minLength, maxLength} from 'vuelidate/lib/validators'
import { createLocationGroup } from "@/api/locations";
import swal from "sweetalert";

export default {
  name: "add-group-dialog",
  mixins: [validationMixin],
  components: {
  },
  validations: {
    form: {
      groupName: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(75)
      }
    }
  },
  data() {
    return {
      show: false,
      valid: true,
      form: {
        groupName: ''
      },
      spinning: false,
      hasError: false,
      errorMsg: ''
    };
  },
  async mounted() {
  
  },
  computed: {
    visible() {
      return this.$store.getters["getCreateDialogVisible"];
    },
  },
  methods: {
    hide() {
      this.$store.commit("hideCreateDialog");
    },

    async addGroup(){
        this.hasError = false
        if (this.form.groupName.length < 3 ) {
          this.hasError = true
          this.errorMsg = 'Require at least 3 character'
          return false
        }
        if (this.form.groupName.length > 75 ) {
          this.hasError = true
          this.errorMsg = 'Group name should not exceed to 75 characters'
          return false
        }
        const payload = JSON.parse(
            JSON.stringify({
              name: this.form.groupName
            })
        );
        this.spinning = true;
        let response = await createLocationGroup(payload)
        if (response) {
          this.$store.commit("setDateRange", {});
          this.$store.dispatch('getLocationsGroups')
          swal("Group Name", "Succesfully created");
        }else{
            swal("Error", "Group name is already exist");
            this.form.groupName = ''
            this.spinning = false;
            return
        }
        this.hide()
        this.form.groupName = ''
        this.spinning = false;
        setTimeout(() => {
          this.$emit('watchAddedGroup', response)
        }, 500);
         
    }
    
  }
};
</script>

<template>
  <v-dialog v-model="visible" persistent scrollable width="500px">
    <v-card>
      <v-card-title class="headline">
        Create Group Name
      </v-card-title>
      <v-card-text>
        <v-text-field
            v-model="form.groupName"
            :counter="75"
            label="Name"
            required
        ></v-text-field>
        <div v-if="hasError"  style="color:red; margin-top: 10px" >
              <p>{{errorMsg}}</p>
            </div>
        <div class="subtitle-2">
          Groups are collections of store locations that can be analyzed together.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-4" depressed tile @click="hide">
          Close
        </v-btn>
        <v-btn
            class="mr-4"
            depressed
            tile
            @click="addGroup"
            v-if="!spinning"
        >
          Create
        </v-btn>
        <b-spinner v-show="spinning" label="Spinning"></b-spinner>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
